import '../App.css';

function FormPageLayout({
    moduleLabel = 'ACCOUNTS',
    title,
    subtitle,
    modeLabel,
    headerExtra,
    children,
}) {
    return (
        <div className="list-page form-page">
            <header className="list-page-header">
                <div className="list-page-header-text">
                    <span className="list-page-module-label">{moduleLabel}</span>
                    <h1 className="list-page-title">{title}</h1>
                    {subtitle ? <p className="list-page-subtitle">{subtitle}</p> : null}
                </div>
                {modeLabel ? (
                    <span className="list-page-header-mode">{modeLabel}</span>
                ) : null}
            </header>

            {headerExtra ? <div className="form-page-header-extra">{headerExtra}</div> : null}

            <div className="form-page-panel">
                {children}
            </div>
        </div>
    );
}

export default FormPageLayout;
